import React, { useEffect, useRef } from "react";
import { youtubeEmbedUrl } from "../../utils/courseResources";

const ResourceVideoModal = ({ resource, onClose }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = "hidden";
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    };
  }, []);

  return (
    <dialog ref={dialogRef} className="resource-video-modal" aria-labelledby="resource-video-title" onCancel={onClose}
      onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
      <div className="resource-video-modal-content">
        <div className="resource-video-modal-header">
          <h2 id="resource-video-title">{resource.name}</h2>
          <button type="button" onClick={onClose} aria-label="Fermer la vidéo" autoFocus>×</button>
        </div>
        <div className="course-video-frame">
          <iframe src={youtubeEmbedUrl(resource.file_path)} title={resource.name} allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
        </div>
      </div>
    </dialog>
  );
};

export default ResourceVideoModal;
